export default theme => ({
    file: {
        display: 'block',
        position: 'relative',
        marginBottom: 36,
    },
})